<template>
  <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" :destroyOnClose="true"
    :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
    <div class="drawer-box" style="width: 100%;height: 100%;padding-bottom: 36px;">
      <section>
        <h4><b>成果摘要</b></h4>
        <div v-html="result.abstractContent" style="padding:0 2em;"> </div>
      </section>
      <section class="flex-box" style="margin: 12px 0;">
        <h4><b>研发成果描述</b></h4>
        <div class="weboffice-node" style="height: 100%"></div>
      </section>
    </div>

    <footer>
      <a-button icon="left" @click="onClose">返回</a-button>
    </footer>

    <template #title>
      <b>{{ result.name }}</b>
    </template>
  </a-drawer>
</template>

<script>
import WebOfficeSDK from '@/Utils/web-office-sdk-v1.1.19.es.js';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    result: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
      wrapStyle: {
        overflow: 'hidden'
      },
      bodyStyle: {
        overflow: 'hidden',
        height: '85%'
      },
      drawerWidth: 1200,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getWPSData();
      }
    },
  },
  mounted() {
    const viewportWidth = window.innerWidth;
    const _width = viewportWidth * 0.8;
    if (_width < 1200) {
      this.drawerWidth = _width;
    }
  },
  methods: {
    // 获取数据
    getWPSData() {
      this.$post('/nhf-app/formularmpresult/detailRmpResultVO', { rmpResultId: this.result.id }).then(res => {
        if (res.success) {
          const webOfficeSdk = WebOfficeSDK.config({
            url: res.data,
            mode: 'simple',
            mount: document.querySelector('.weboffice-node'),
          });

          webOfficeSdk.on('fileOpen', (data) => {
            console.log('打开文档成功: ', data);
          });

          webOfficeSdk.on('webSocketStatus', (err) => {
            console.log('error', err);
          });
        }
      });
    },
    onClose() {
      this.$emit('close');
    },
  }
};
</script>


<style lang="scss" scoped>
.containers {
  width: 100%;
  flex: 1;
  height: calc(100vh - 100px);
}

::v-deep .drawer {
  overflow: hidden;

  .ant-drawer-wrapper-body,
  .ant-drawer-wrapper-body {
    overflow: hidden;
  }
}

::v-deep .ant-checkbox-wrapper-disabled {
  display: none;
}

.flex-box {
  display: flex;
  flex-direction: column;
  height: 100%;
}

footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 56px;
  border-top: 1px solid #e9e9e9;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ant-btn {
    margin-right: 20px;
    min-width: 60px;
  }

  >div {
    display: flex;
    align-items: center;
  }
}
</style>
